

import { defineComponent,PropType,ref,Ref,provide,inject,watchEffect,onMounted,computed } from 'vue';
import inputFile from "@/components/inputFile.component.vue";
import {ObjFile} from "@/models/objFiles.interface";


export default defineComponent({
 components:{
    inputFile
 },
 setup(){
  let arrComponents:Ref<string[]> =ref([""]); 
  let arrFiles:Ref<File[]> = inject ("loaded_files") as Ref<File[]>;

  //const messages:Ref<Message[]>=inject("messages_from_phone") as Ref<Message[]>;
  
  const atender_archivo=(pasoalgo)=>{
    arrComponents.value.push("");
  };
  const remove_file =(object)=>{
   arrComponents.value.splice(object.position,1);
    arrFiles.value.splice(object.position,1);
  };
  const add_file=(object)=>{
    arrFiles.value.splice(object.position,1,object.file);

  }
  return {arrComponents,atender_archivo,add_file,remove_file}
 }
});
